module.exports = __webpack_public_path__ + "static/media/ic_delete.3e3602a3.svg";